// eslint-disable-next-line import/prefer-default-export
export const SET_DATA_CERTIFICATES = "[CERTIFICATES_TYPES] SET_DATA_CERTIFICATES";
export const GET_GENERATED_CERTIFICATES = "[CERTIFICATES_TYPES] GET_GENERATED_CERTIFICATES";
export const GET_DATA_CERTIFICATES_BY_CUSTOMER =
  "[CERTIFICATES_TYPES] GET_DATA_CERTIFICATES_BY_CUSTOMER";
export const GET_CERTIFICATE_PDF = "[CERTIFICATES_TYPES] GET_CERTIFICATE_PDF";
export const SEND_NOTIFY_CERTIFICATE = "[CERTIFICATES_TYPES] SEND_NOTIFY_CERTIFICATE";
